/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type CommissionSettlement = typeof CommissionSettlement[keyof typeof CommissionSettlement];


export const CommissionSettlement = {
  split: 'split',
  debt: 'debt',
} as const;
